/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SponsorshipResolveResponse } from '../models/SponsorshipResolveResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SponsorshipService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Resolve a sponsorship code
     * Validates whether a sponsorship code exists and returns the type of entity (client or society) that owns it.
     * @returns SponsorshipResolveResponse Sponsorship code resolved successfully.
     * @throws ApiError
     */
    public sponsorshipControllerResolve({
        code,
    }: {
        /**
         * Sponsorship code to resolve
         */
        code: string,
    }): CancelablePromise<SponsorshipResolveResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/sponsorship/resolve',
            query: {
                'code': code,
            },
            errors: {
                400: `Validation error. Code query parameter is required.`,
                404: `Sponsorship code not found.`,
            },
        });
    }
}
